import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef } from 'react';
import Decimal from 'decimal.js';
import { Row, TextButton, Tooltip } from 'seagull';
import { useLocaleKeys } from '~/i18n';
import { addStage, removeStage, setFinalStage, calculateStages, isValueTypeDollars, stagesTextsPath, getDisabledReasonTooltip } from './BillingStagesSelect.utils';
import { Stage } from './Stage';
export const BillingStagesSelect = (param)=>{
    let { discount, totalRate, isAmendment, effectiveDate, stageClassName, disabledReason, oneTimeInStagesBilling, setOneTimeInStagesBilling } = param;
    const { t: stagesTexts } = useLocaleKeys(stagesTextsPath);
    const stages = oneTimeInStagesBilling.stages();
    const valueType = oneTimeInStagesBilling.valueType();
    const billingRef = useRef(oneTimeInStagesBilling);
    billingRef.current = oneTimeInStagesBilling;
    const setOneTimeInStagesBillingRef = useRef(setOneTimeInStagesBilling);
    setOneTimeInStagesBillingRef.current = setOneTimeInStagesBilling;
    useEffect(()=>{
        if (isValueTypeDollars(valueType)) {
            const currentBilling = billingRef.current;
            const currentStages = currentBilling.stages();
            const newStages = [
                ...currentStages
            ];
            const lastStageIndex = newStages.length - 1;
            const currentLastStageValue = newStages[lastStageIndex].value;
            setFinalStage(newStages, valueType, totalRate);
            const newLastStageValue = newStages[lastStageIndex].value;
            if (!currentLastStageValue.equals(newLastStageValue)) setOneTimeInStagesBillingRef.current(currentBilling.setStages(newStages));
        }
    }, [
        totalRate,
        valueType
    ]);
    const handleAddStage = ()=>{
        setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(addStage(stages)));
    };
    const handleRemoveStage = (indexToRemove)=>{
        setOneTimeInStagesBilling(oneTimeInStagesBilling.setStages(removeStage(stages, indexToRemove)));
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            stages.map((stage, index, param)=>{
                let { length } = param;
                return /*#__PURE__*/ _jsx(Stage, {
                    stage: stage,
                    discount: discount,
                    stageClassName: stageClassName,
                    totalRate: totalRate,
                    discountedTotalRate: totalRate.mul(new Decimal(1).minus(discount.div(100))),
                    isLast: index === length - 1,
                    isFirst: index === 0,
                    index: index,
                    disabledReason: disabledReason,
                    oneTimeInStagesBilling: oneTimeInStagesBilling,
                    totalSumExceedsRate: stages.reduce((acc, stage)=>acc.plus(stage.value), new Decimal(0)).gt(isValueTypeDollars(valueType) ? totalRate : new Decimal(100)),
                    onRemove: ()=>handleRemoveStage(index),
                    onChange: (newStage, newValueType)=>{
                        const valueTypeChanged = newValueType != null && newValueType !== valueType;
                        const stageValueChanged = !newStage.value.equals(stages[index].value);
                        if (valueTypeChanged && !stageValueChanged) {
                            setOneTimeInStagesBilling(oneTimeInStagesBilling.setValueType(newValueType).setStages(calculateStages({
                                length: stages.length,
                                totalRate,
                                valueType: newValueType
                            })));
                            return;
                        }
                        const effectiveValueType = newValueType !== null && newValueType !== void 0 ? newValueType : valueType;
                        const newStages = [
                            ...stages
                        ];
                        newStages[index] = newStage;
                        setFinalStage(newStages, effectiveValueType, totalRate);
                        setOneTimeInStagesBilling(valueTypeChanged ? oneTimeInStagesBilling.setValueType(newValueType).setStages(newStages) : oneTimeInStagesBilling.setStages(newStages));
                    },
                    effectiveDate: effectiveDate,
                    isAmendment: isAmendment
                }, index);
            }),
            /*#__PURE__*/ _jsx(Row, {
                children: /*#__PURE__*/ _jsx(Tooltip, {
                    title: getDisabledReasonTooltip({
                        texts: stagesTexts,
                        disabledReason
                    }) || (stages.length >= 6 ? stagesTexts.maxStagesReached() : ''),
                    children: /*#__PURE__*/ _jsx(TextButton, {
                        bi: {
                            name: 'add_billing_stage_in_service_builder'
                        },
                        disabled: !!disabledReason || stages.length >= 6,
                        onClick: handleAddStage,
                        underline: "none",
                        testId: "add-stage",
                        children: stagesTexts.addStage()
                    })
                })
            })
        ]
    });
};
